export const columnFilterMixin = {
  data: () => ({
    columnFilters: {},
  }),
  computed: {
    // Luôn sử dụng filteredItems để render table/mobile cards
    filteredItems() {
      const list = this.gridMainList || [];
      return list.filter(item => {
        return Object.keys(this.columnFilters).every(key => {
          if (!this.columnFilters[key]) return true;
          const itemValue = String(item[key] || '').toLowerCase();
          const filterValue = String(this.columnFilters[key]).toLowerCase();
          return itemValue.includes(filterValue);
        });
      });
    }
  },
  methods: {
    // Khởi tạo các key filter dựa trên headers
    initColumnFilters(headers) {
      headers.forEach(h => {
        if (h.value) {
          this.$set(this.columnFilters, h.value, '');
        }
      });
    }
  }
};